import React, { Fragment } from 'react';
import { DialogTitle, DialogContent, DialogActions, Button, Divider } from '@material-ui/core'

import { PassengerBookings } from 'components'

export const PassengerInfoModal = (props) => (
  <Fragment>
    <DialogTitle>Інформація про пасажира</DialogTitle>
    <Divider />
    <DialogContent>
      <PassengerBookings />
    </DialogContent>
    <DialogActions>
      <Button onClick={props.onClose} color='secondary'>
        Вийти
      </Button>
    </DialogActions>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PassengerInfoModal/PassengerInfoModal.js